import CorvuDialog from '@corvu/dialog'
import { DialogShell } from '@forest/shared/solid'
import { Show } from 'solid-js'
import {
  detailOverlayAnimation,
  dialogPanelAnimation,
} from '~/lib/dialog-animation'
import { m } from '~/paraglide/messages'
import { DialogCloseButton, DialogPrimaryButton } from './dialog-buttons'

// The starter pack offer dialog (GLOSSARY.md): the one-time announcement that
// the user has earned the starter pack. All copy is its own fixed web
// Lokalise copy — the contents sentence included, never the card's
// description; the image is the display metadata's offer_img_url, already
// loaded when the dialog opens (the shell waits for it), in a 200px-tall
// area, scaled down rather than cropped. The dialog shows without one. `View offer` and the close button are its only
// answers; it logs no analytics event until the tracking spec names one.
export function StarterPackOfferDialog(props: {
  imageUrl: string | undefined
  // The close button: dismisses, nothing more.
  onClose: () => void
  // `View offer`: the shell takes the user to the starter-pack card.
  onViewOffer: () => void
  open: boolean
}) {
  return (
    <DialogShell
      open={props.open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) props.onClose()
      }}
      closeOnEscapeKeyDown={false}
      testId="starter-pack-offer-dialog"
      class={`z-30 flex w-[300px] flex-col items-center gap-4 p-6 text-center text-[#333] outline-none ${dialogPanelAnimation}`}
      overlayClass={detailOverlayAnimation}
    >
      <>
        <DialogCloseButton
          disabled={!props.open}
          onClose={() => props.onClose()}
          testId="starter-pack-offer-close"
        />

        <Show when={props.imageUrl}>
          {(url) => (
            <img
              src={url()}
              alt=""
              data-testid="starter-pack-offer-image"
              class="h-[200px] w-full object-contain"
            />
          )}
        </Show>

        <div class="flex flex-col gap-3">
          <CorvuDialog.Label class="whitespace-pre-line text-lg font-semibold text-[#00524F]">
            {m.starter_pack_pop_up_title()}
          </CorvuDialog.Label>
          <CorvuDialog.Description class="whitespace-pre-line text-[#00524F]/75">
            {m.starter_pack_pop_up_content()}
          </CorvuDialog.Description>
        </div>

        <DialogPrimaryButton
          data-testid="starter-pack-offer-view"
          disabled={!props.open}
          onClick={() => props.onViewOffer()}
        >
          {m.view_offer()}
        </DialogPrimaryButton>
      </>
    </DialogShell>
  )
}
